import { createMuiTheme } from 'material-ui/styles';
import blue from 'material-ui/colors/blue';
import red from 'material-ui/colors/red';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#40bfe8' },
    input: red,
    accent: {
      ...blue
    },
    error: red,
  }
});

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js